export enum PolicyRuleParameterKeys {
  MALICIOUS_THRESHOLD = 'maliciousThreshold',
}

export const PolicyRuleParametersLegend = {
  'Malicious score threshold exceeded': {
    parameter: PolicyRuleParameterKeys.MALICIOUS_THRESHOLD,
    initialValue: 0,
  },
};
